// extracted by css-extract-rspack-plugin
export default {"base":"YDntGQb2Misj0RqR"};